import { useQuery } from "@tanstack/react-query";
import { getUpPromoteJoinStatus } from "@/utils/upPromoteJoinStatus.functions";

/** هل التسجيل الجديد عبر UpPromote مفعَّل؟ أثناء التحميل أو الخطأ = false. */
export function useUpPromoteJoinEnabled(): boolean {
  const { data } = useQuery({
    queryKey: ["uppromote-join-status"],
    queryFn: () => getUpPromoteJoinStatus(),
    staleTime: 60_000,
  });
  return data?.enabled === true;
}
